module.exports = __webpack_public_path__ + "static/img/shared-betting-history-bg.26c65f1.png";